import axios from 'axios';

import { SFCCPromoFilter } from 'composables/Product/ProductFilterModule/productFilterModuleTypes';

export const fetchSfccPromoFilter = async (
  sfccPromoApiUrl: string
): Promise<SFCCPromoFilter | null> => {
  try {
    const { data } = await axios.get(sfccPromoApiUrl);
    return data;
  } catch (error) {
    console.error(`fetchSfccPromoFilter request for ${sfccPromoApiUrl} failed:`, error);
    return null;
  }
};
